import React, { useState, useRef } from 'react';
import { connect, Provider } from 'react-vuex';

import vuexStore from '../../../shared/store';
import { EventBus } from '../../../shared/event-bus';

function mapDispatchToProps(dispatch) {
  return {
    addItemToCart: (product) => dispatch('cart/addItem', product),
  };
}

export const _ValorantAccountSelector = connect(
  () => ({}),
  mapDispatchToProps,
  () => ({}),
  () => ({})
)(
  ({
    valorantPackage: {
      ranked,
      region,
      agents,
      old_price,
      price,
      id,
      title,
      product_image,
      rank_tier,
      rank_division,
    },
    addItemToCart,
  }) => {
    const ref = useRef(null);
    const [isAgentSelectorOpen, setIsAgentSelectorOpen] = useState(true);
    const onAddToCart = (event) => {
      const { current: form } = ref;

      if (!form && !ranked) {
        setIsAgentSelectorOpen(true);
        return;
      }

      if (ranked) {
        addItemToCart({
          description: 'Valorant ' + title,
          price: parseFloat(price),
          extra: { id, type: 'valorant' },
        });
      }

      if (!ranked && form) {
        const formData = new FormData(form);
        const agent = formData.get('agent');
        addItemToCart({
          description: 'Valorant ' + title,
          price: parseFloat(price),
          extra: { id, type: 'valorant', agent_id: agent },
        });
      }

      // The button is sometimes nested in clickable cards, which we don't
      // want to click when adding an item to the cart.
      event.stopPropagation();

      EventBus.$emit('item-added-to-cart');
    };
    return (
      <div className="valorant-account-selector">
        <div className="valorant-account-selector__top-row">
          <h2 className="valorant-account-selector__heading text-2xl font-bold leading-none">
            {title}
          </h2>
          <img
            className="valorant-account-selector__rank-gradient"
            src="/images/valorant/valorant_rank_shine.png"
          />

          <img
            className="valorant-account-selector__rank-image"
            src={product_image ?? `/images/valorant/account-page/${rank_tier.toLowerCase()}_big.png`}
          />

          <div className="valorant-account-selector__region">
            {region} REGION
          </div>
          <div className="valorant-account-selector__prices">
            {old_price && (
              <p className="valorant-account-selector__old-price">USD 149.99</p>
            )}
            <p className="valorant-account-selector__new-price">
              <span className="valorant-account-selector__new-price-text">
                USD
              </span>{' '}
              {price}
            </p>
          </div>
        </div>
        <div className="valorant-account-selector__middle-row">
          <div className="valorant-account-selector__banner">
            <i className="fa fa-info-circle" />
            Hurry! Only 10{' '}
            <span>
              {title} accounts
            </span>{' '}
            left in stock!
          </div>
          <button
            onClick={onAddToCart}
            className="valorant-account-selector__add-to-cart"
          >
            Add to Cart
          </button>
        </div>
        {isAgentSelectorOpen && (
          <form ref={ref} className="valorant-account-selector__agent-grid">
            {agents.map(({ name, role, image_path, id }) => {
              return (
                <label
                  key={name}
                  className="valorant-account-selector__agent-container"
                >
                  <input
                    className="valorant-account-selector__agent-radio"
                    name="agent"
                    type="radio"
                    value={id}
                  />
                  <img
                    src={image_path}
                    className="valorant-account-selector__agent-icon"
                  />
                  <div className="valorant-account-selector__text-wrapepr">
                    <h6 className="valorant-account-selector__agent-name text-xs font-semibold leading-none">
                      {name}
                    </h6>
                    <p className="valorant-account-selector__agent-role">
                      {role}
                    </p>
                  </div>
                </label>
              );
            })}
          </form>
        )}
        <img
          alt="ray of light at the bottom"
          className="valorant-account-selector__shine-bottom"
          src="/images/valorant/valorant_shine_bottom.png"
        />

        <img
          alt="big valorant logo"
          className="valorant-account-selector__header-image"
          src="/images/valorant/valorant_account_selector_header_image.png"
        />

        {!ranked && (
          <button
            onClick={() => setIsAgentSelectorOpen(!isAgentSelectorOpen)}
            className="valorant-account-selector__agent-selector-btn"
          >
            <i
              className={`fa ${
                isAgentSelectorOpen ? 'fa-chevron-up' : 'fa-chevron-down'
              }`}
            />
            <span>Agent Selector</span>
          </button>
        )}
      </div>
    );
  }
);

export const ValorantAccountSelector = (props) => {
  return (
    <Provider store={vuexStore}>
      <_ValorantAccountSelector {...props} />
    </Provider>
  );
};
